import { render } from "./ClassesBlock.vue?vue&type=template&id=2544f480&scoped=true&bindings={\"showNewClassInput\":\"data\",\"newClassName\":\"data\",\"showDeleteButtons\":\"data\",\"handleRemoveClass\":\"options\",\"saveNewClass\":\"options\",\"onInputKeyup\":\"options\"}"
import script from "./ClassesBlock.vue?vue&type=script&lang=js"
export * from "./ClassesBlock.vue?vue&type=script&lang=js"

import "./ClassesBlock.vue?vue&type=style&index=0&id=2544f480&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-2544f480"

export default script
import QChip from 'quasar/src/components/chip/QChip.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QBtnGroup from 'quasar/src/components/btn-group/QBtnGroup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QChip,QAvatar,QSpace,QInput,QBtn,QBtnGroup});
